import type { FragmentType } from 'src/gql';
import type { SalesforceAccount } from 'src/types/salesforce-account';
import React from 'react';
import { HouseholdClientFragment } from 'src/components/advisor-dashboard/clients/fragments';
import { unmaskFragment } from 'src/gql';

import SfContactTooltips from './sf-contact-tooltips';

type Props = {
  readonly household: FragmentType<typeof HouseholdClientFragment>;
};

/**
 * Adapter component that converts GraphQL household data to Salesforce format
 * to reuse existing SfContactTooltips component
 */
export function HouseholdContactTooltips({ household: householdFrag }: Props) {
  // Convert GraphQL data to Salesforce format for compatibility with SfContactTooltips
  const household = unmaskFragment(HouseholdClientFragment, householdFrag);
  const mockSalesforceAccount: SalesforceAccount = {
    Id: household.salesforceAccountId || household.id,
    Name: household.name,
    CreatedDate: new Date().toISOString(),
    Qualified_Client__c: false,
    Qualified_Purchaser__c: false,
    Accredited_Investor__c: false,
    Contacts: {
      records: [
        // Primary contact
        ...[
          {
            Id: household.primaryClient.id,
            FirstName: household.primaryClient.user.firstName,
            LastName: household.primaryClient.user.lastName,
            Email: household.primaryClient.user.email,
            Phone: household.primaryClient.user.phoneNumber || undefined,
            XLR8CS__Primary_Contact__c: true,
            Co_Client__c: false,
            XLR8CS__Informal_Name__c: undefined,
          },
        ],
        // Co-client
        ...(household.coClient
          ? [
              {
                Id: household.coClient.id,
                FirstName: household.coClient.user.firstName,
                LastName: household.coClient.user.lastName,
                Email: household.coClient.user.email,
                Phone: household.coClient.user.phoneNumber || undefined,
                XLR8CS__Primary_Contact__c: false,
                Co_Client__c: true,
                XLR8CS__Informal_Name__c: undefined,
              },
            ]
          : []),
      ],
    },
  };

  return <SfContactTooltips account={mockSalesforceAccount} />;
}
